import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  get_candidate_invited_jobs_action,
} from "../../../../redux/_actions";

function useJobInvites(props) {
  const [loading, setLoading] = useState(false);
  const [allJobs, setAllJobs] = useState([]);
  // const [jobDetails, setJobDetails] = useState({});
  //PAGINATION
  const [nextPage, setNextPage] = useState(null);
  const [pageNum, setPageNum] = useState(1);
  const [lastElement, setLastElement] = useState(null);
  const [newJobsLoading, setNewJobsLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

 
  const { invitedJobsData } = useSelector(
    (state) => state.get_candidate_invited_jobs_reducer
  );

  useEffect(() => {
    setLoading(true);
    callApi();
  }, []);

  useEffect(() => {
    if (nextPage !== null) {
      setNewJobsLoading(true);
      callApi();
    }
  }, [pageNum]);

  useEffect(() => {
    if (invitedJobsData?.data) {
      let data = invitedJobsData.data?.results;
      let results = allJobs;
      data.forEach((newItem) => {
        if (!results.find((item) => item.id === newItem.id)) {
          results.push(newItem);
        }
      });
      setAllJobs(results);
      setNextPage(invitedJobsData?.data.next);
    }
  }, [invitedJobsData]);

  //infinite scroll pagination
  useEffect(() => {
    const currentElement = lastElement;
    const currentObserver = observer.current;

    if (currentElement) {
      currentObserver.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        currentObserver.unobserve(currentElement);
      }
    };
  }, [lastElement]);

  const observer = useRef(
    new IntersectionObserver((entries) => {
      const first = entries[0];
      if (first.isIntersecting) {
        setPageNum((no) => no + 1);
      }
    })
  );

  // get all applied jobs
  const callApi = async () => {
    await dispatch(get_candidate_invited_jobs_action(pageNum));
    setLoading(false);
    setNewJobsLoading(false);
  };


  const onViewJobDetails = (id, index) => {
    navigate("/applied-jobs-expanded", {
      state: {
        job_id: id,
        index: index,
      },
    });
  };

  return {
    allJobs,
    loading,
    newJobsLoading,
    invitedJobsData,

    setLastElement,
    onViewJobDetails,
  };
}

export default useJobInvites;
